import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import FormularioRegistroEntrenador from './components/entrenador/registroEntrenadores/registroEntrenador';
import FormularioRegistroDeportista from './components/deportista/registroDeportistas/registro/registroDeportista';
import RegistroPerfil from './components/deportista/registroDeportistas/userData/deportistaPerfil';
import DeportistaObjetivo from './components/deportista/registroDeportistas/objetivos/deportistaObjetivo';
import DeportistaLogin from './components/deportista/loginDeportistas/login/loginDeportistas';
import PasswordResetRequest from './components/deportista/loginDeportistas/recuperacionContraseña/recuperacionContraseña';
import PasswordResetForm from './components/deportista/loginDeportistas/cambiarContraseña/cambiarContraseña';
import Actividad from './components/deportista/actividad/pantallaActividad';
import Entrenamiento from './components/deportista/entrenamiento/pantallaEntrenamiento';
import Perfil from './components/deportista/perfil/perfilDeportista'
import Encuesta from './components/deportista/encuestas/encuesta'
import Maximos from './components/deportista/maximosDeportistas/maximos'
import BuscarEntrenadores from './components/deportista/buscarEntrenador/buscarEntrenador/buscarEntrenador';
import DetalleBloque from './components/deportista/ejerciciosData/ejercicioBloque';
import MovimientoEjercicio from './components/deportista/ejerciciosData/movimientos/movimientoEjercicio';


const RoutesComponent = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const sessionId = localStorage.getItem("sessionId");

    const publicRoutes = ['/login', '/recuperar', '/registro'];

    const isPublicRoute = publicRoutes.includes(location.pathname) ||
    location.pathname.startsWith('/reset-password') ||
    location.pathname.startsWith('/verify');

    if (!sessionId && !isPublicRoute) {
      navigate("/login");
    } else if (sessionId && isPublicRoute) {
      navigate("/dashboard");
    }
  }, [navigate, location.pathname]);

  return (
    <Routes>
      <Route path="/recuperar" element={<PasswordResetRequest />} />
      <Route path="/login" element={<DeportistaLogin />} />
      <Route path="/entrenador" element={<FormularioRegistroEntrenador />} />
      <Route path="/registro" element={<FormularioRegistroDeportista />} />
      <Route path="/verify/:token" element={<RegistroPerfil />} />
      <Route path="/perfil/editar" element={<RegistroPerfil />} />
      <Route path="/objetivo" element={<DeportistaObjetivo />} />
      <Route path="/dashboard" element={<Actividad />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
      <Route path="/dashboard/maximos" element={<Maximos />} />
      <Route path="/entrenamiento" element={<Entrenamiento />} />
      <Route path="/perfil" element={<Perfil />} />
      <Route path="/reset-password/:uid/:token" element={<PasswordResetForm />} />
      <Route path="/encuesta/:idEncuesta/:fecha" element={<Encuesta />} />
      <Route path='/entrenadores' element={<BuscarEntrenadores />} />
      <Route path="/entrenamiento/bloque/" element={<DetalleBloque/>} />
      <Route path="/entrenamiento/bloque/movimiento" element={<MovimientoEjercicio/>}/>
    </Routes>
  );
};

export default RoutesComponent;
